export default __webpack_public_path__ + "static/next-project-light-5bce61fcdb50e1d8eb45dfce35bacccf.svg";